var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAbrirIco = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M9.451-18.39H9.337a4.15,4.15,0,0,1,4.034-3.585,4.15,4.15,0,0,1,4.165,3.432A4.15,4.15,0,0,1,14.788-13.9a5.7,5.7,0,0,0-.351-1.206,2.906,2.906,0,0,0,1.889-3.255,2.906,2.906,0,0,0-2.907-2.39,2.906,2.906,0,0,0-2.828,2.482A5.7,5.7,0,0,0,9.451-18.39ZM21.891-7.678l-.722-3.647a3.01,3.01,0,0,0-1.9-2.241l-1.785-.674-.437,1.187,1.776.665A1.738,1.738,0,0,1,19.9-11.078l.722,3.666c-.665,0-1.681.066-2.422.085a3.4,3.4,0,0,1,.18.627l.133.627,2.165-.076a1.33,1.33,0,0,0,.95-.484,1.282,1.282,0,0,0,.266-1.045ZM5.272-12.958a4.169,4.169,0,0,1,4.175-4.16,4.169,4.169,0,0,1,4.163,4.172A4.169,4.169,0,0,1,9.441-8.779,4.179,4.179,0,0,1,5.272-12.958Zm1.263,0a2.906,2.906,0,0,0,2.906,2.906,2.906,2.906,0,0,0,2.906-2.906,2.906,2.906,0,0,0-2.906-2.906,2.906,2.906,0,0,0-2.055.851A2.906,2.906,0,0,0,6.535-12.958ZM13.183-2.417c-2.5.057-5,.057-7.5,0L4.408-2.464A17.55,17.55,0,0,1,2.29-2.549L3.021-6.2A1.757,1.757,0,0,1,4.133-7.507l1.776-.674L5.434-9.368,3.648-8.7a3.039,3.039,0,0,0-1.9,2.251L1-2.806a1.254,1.254,0,0,0,.247,1.035,1.273,1.273,0,0,0,.95.494q3.618.171,7.246.171c2.412,0,4.834-.057,7.227-.171a1.282,1.282,0,0,0,.948-.49,1.282,1.282,0,0,0,.248-1.039l-.722-3.647a3.029,3.029,0,0,0-1.9-2.251l-1.776-.665-.446,1.178,1.785.674a1.776,1.776,0,0,1,1.111,1.311L16.63-2.54c-.731,0-1.462.057-2.2.076Z",
    transform: "translate(-0.973 21.976)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iconos_menu_flotante"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconos_menu_flotante",
    clipPath: "url(#clip-iconos_menu_flotante)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_cerrado_movil",
    transform: "translate(0.557 23.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226",
    transform: "translate(0.973 -21.976)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M-4.027-26.976H26.41V3.391H-4.027Z",
    transform: "translate(-0.721 22.228)",
    fill: "#001e50"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAbrirIco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/abrir_ico.2b05e4e7.svg";
export { ForwardRef as ReactComponent };